import classNames from "classnames";
import * as React from "react";
import styles from "./Navbar.module.css";

export interface HamburgerIconProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

export const HamburgerIcon: React.FC<HamburgerIconProps> = ({
  isOpen,
  onClick,
  className,
}) => {
  return (
    <button
      className={classNames(
        styles.hamburgerButton,
        isOpen && styles.hamburgerOpen,
        className,
      )}
      onClick={onClick}
      aria-label={isOpen ? "Close menu" : "Open menu"}
      aria-expanded={isOpen}
      type="button"
    >
      <span className={styles.hamburgerLine} />
      <span className={styles.hamburgerLine} />
      <span className={styles.hamburgerLine} />
    </button>
  );
};
